module.exports = __webpack_public_path__ + "img/buy-dmkt.e444875e.jpg";